<template>
  <div class="course-detail container">
    <div class="header">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/course/list' }">在线课程</el-breadcrumb-item>
        <el-breadcrumb-item>课程详情</el-breadcrumb-item>
      </el-breadcrumb>
      
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">发布状态：</span>
            <el-switch
              v-model="course.status"
              @change="updateCourseInfo"
            ></el-switch>
          </div>
        </div>
        <div class="right">
          <el-button
            type="primary"
            @click="handleToPreview"
          >预览</el-button>
        </div>
      </div>
    </div>
    <CourseInfo
      class="info-card"
      :content="course"
    />
    <div class="main">
      <div class="tabs">
        <div
          :class="{'tab-item': true, 'active': tabKey == 'chapter'}"
          @click="handleTabChange('chapter')"
        >课程大纲</div>
        <el-divider direction="vertical"></el-divider>

        <div
          :class="{'tab-item': true, 'active': tabKey == 'resource'}"
          @click="handleTabChange('resource')"
        >在线讲义</div>

        <el-divider direction="vertical"></el-divider>
        <div
          :class="{'tab-item': true, 'active': tabKey == 'paper'}"
          @click="handleTabChange('paper')"
        >随堂练习</div>
        <el-divider direction="vertical"></el-divider>
        <div
          :class="{'tab-item': true, 'active': tabKey == 'comment'}"
          @click="handleTabChange('comment')"
        >产品评价</div>
      </div>
      <Chapter v-if="tabKey=='chapter'"></Chapter>
      <Resource v-if="tabKey=='resource'"></Resource>

      <Paper v-if="tabKey=='paper'"></Paper>
      <Comment v-if="tabKey=='comment'"></Comment>
    </div>
  </div>
</template>

<script>
import CourseInfo from '@/components/card/CourseInfo'
import Chapter from './courseChapter'
import Resource from './courseResource'
import Paper from './coursePaper'
import Comment from './courseComment'
import {
  courseOne, courseUpdateStatus, courseChapterList, courseChapterCreate,
  courseChapterUpdate, courseChaptersUpdate, courseChapterDestroy
} from '@/api/course'

export default {
  components: {
    CourseInfo,
    Chapter,
    Resource,
    Paper,
    Comment
  },
  data() {
    return {
      tabKey: 'chapter',
      course: {}
    }
  },
  created() {
    this.fetchCourseInfo()
  },
  methods: {
    // 课程基本信息
    fetchCourseInfo() {
      courseOne({ id: this.$route.params.courseId }).then(res => {
        this.course = res
        this.course.status = this.course.status == 1 ? true : false
      })
    },
    // 更新课程在线状态
    updateCourseInfo() {
      courseUpdateStatus({ id: this.$route.params.courseId, status: this.course.status ? 1 : 0 }).then(res => {
        this.$message.success(`发布状态更新成功`)
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    handleTabChange(key) {
      this.tabKey = key
    },
    // 预览
    handleToPreview() {
      if (this.course) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/course/detail/${this.course.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/course/detail/${this.course.id}`)
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.course-detail {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .info-card {
    margin-top: 10px;
  }
  .main {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    padding: 20px;
    overflow: hidden;
    margin-top: 10px;

    .tabs {
      position: absolute;
      left: 20px;
      top: 20px;
      height: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tab-item {
        font-size: 14px;
        cursor: pointer;

        &.active {
          font-size: 16px;
          font-weight: bold;
          cursor: default;
        }
      }
    }
  }
}
</style>
